import { render, staticRenderFns } from "./ReportFunnel.vue?vue&type=template&id=2f0ea0f6&scoped=true&"
import script from "./ReportFunnel.vue?vue&type=script&lang=js&"
export * from "./ReportFunnel.vue?vue&type=script&lang=js&"
import style0 from "./ReportFunnel.vue?vue&type=style&index=0&id=2f0ea0f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0ea0f6",
  null
  
)

export default component.exports